import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { getAssetPath } from './utils/assetHelper';

// Import global styles and libraries
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'animate.css';
import './styles/main.scss';

// Import Bootstrap JS
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// Import jQuery first
import $ from 'jquery';
window.$ = $;

// Import moment.js for date handling
import moment from 'moment';
window.moment = moment;

// Import DataTables after jQuery
import 'datatables.net';
import 'datatables.net-bs5';
import 'datatables.net-responsive';

// Import DateRangePicker after jQuery and moment
import 'daterangepicker';
import 'daterangepicker/daterangepicker.css';

// Log environment information to help debug asset loading issues
console.log('Environment mode:', import.meta.env.MODE);
console.log('Base URL:', import.meta.env.BASE_URL);
console.log('Example asset path:', getAssetPath('assets/images/avatar-2.png'));

// Check font loading
const checkFontLoading = () => {
  console.log('Font loading check - document.fonts.ready:', typeof document.fonts !== 'undefined');
  if (typeof document.fonts !== 'undefined') {
    document.fonts.ready.then(() => {
      console.log('Fonts loaded successfully');
    }).catch((error) => {
      console.error('Error loading fonts:', error);
    });
  }
};

// Make sure jQuery and moment are available globally
$(document).ready(function() {
  console.log('jQuery is ready');
  console.log('moment is ready:', typeof window.moment === 'function');
  
  // Check if plugins are loaded
  console.log('DataTables is loaded:', typeof $.fn.DataTable === 'function');
  console.log('DateRangePicker is loaded:', typeof $.fn.daterangepicker === 'function');
  
  // Check if fonts are loaded
  checkFontLoading();
  
  // Check if assets are loading correctly
  const testImage = new Image();
  testImage.onload = () => console.log('Test image loaded successfully');
  testImage.onerror = () => console.error('Test image failed to load');
  testImage.src = getAssetPath('assets/images/avatar-2.png');
});

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
); 